export default function extractId() {
  const item = this.item ? this.item : {};

  return item.id || item.gid || item.funderId;
}
